module.exports = __webpack_public_path__ + "img/Logo_Prym-Soft_sygnet.0ba61377.png";